import styled from 'styled-components';

export const Iframe = styled.iframe`
  margin-top: 15px;
  margin-bottom: 30px;
`;
